import React, { useEffect } from 'react';
import { get } from 'lodash';
import { Button, Card } from '../components';
import ContainerPersonalInformationTeaser from './cpc/ContainerPersonalInformationTeaser';
import BayadCenterLogo from '../assets/images/bayad-center@2x.png';
import VisaLogo from '../assets/images/visa@2x.png';
import MasterCardLogo from '../assets/images/1280px-Mastercard-logo@2x.png';
// import LandBankLogo from '../assets/images/1200px-Landbank@2x.png';
import GCashLogo from '../assets/images/gcash@2x.png';
import { RouteWithSubRoutes } from '../Routers';
import { useHistory } from 'react-router-dom';


const Dashboard = ({ routes }) => {
  const history = useHistory()

  const goEditProfile = e => {
    e.preventDefault()
    history.push('/profile')
  }

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    document.body.classList.remove('has-modal')
  }, [])

  return (
    <div className="dashboard-container">
      <div className="left-pane">
        <Card>
          <Card.Header>
            <b className="title font-medium">Personal Information</b>
            <Button type="button" onClick={goEditProfile} className="!w-auto">Edit</Button>
          </Card.Header>
          <Card.Body>
            <ContainerPersonalInformationTeaser />
          </Card.Body>
        </Card>
        {/* <Card>
          <Card.Header>
            <b className="title font-medium">We Accept Payments Via</b>
          </Card.Header>
          <Card.Body>
            <div className="flex space-x-2 items-center justify-center">
              <div className="w-20 h-20"><img alt="Bayad Center Logo" src={BayadCenterLogo} /></div>
              <div className="w-20 h-20"><img alt="Visa Logo" src={VisaLogo} /></div>
              <div className="w-20 h-20"><img alt="Master Card Logo" src={MasterCardLogo} /></div>

              <div className="w-20 h-20"><img alt="GCash Logo" src={GCashLogo} /></div>
            </div>
          </Card.Body>
        </Card> */}
        {/* <Card>
          <Card.Header>
            <b className="title">Our Partners</b>
          </Card.Header>
          <Card.Body>
            <div className="flex my-1 space-x-2 items-center justify-center">
              <div className="w-20 h-20"><img alt="partners" src="https://ltfrb.gov.ph/wp-content/uploads/2017/09/PhilippinePresidentialSeal160x160.png" /></div>
              <div className="w-20 h-20"><img alt="partners" src="https://ltfrb.gov.ph/wp-content/uploads/2017/09/DOTr.png" /></div>
              <div className="w-20 h-20"><img alt="partners" src="https://ltfrb.gov.ph/wp-content/uploads/2017/09/Land_Transportation_Office.png" /></div>
              <div className="w-20 h-20"><img alt="partners" src="https://ltfrb.gov.ph/wp-content/uploads/2017/09/Civil_Service_Commission.png" /></div>
              <div className="w-20 h-20"><img alt="partners" src="https://ltfrb.gov.ph/wp-content/uploads/2017/09/Department_of_Budget_and_Management_Official_Seal.png" /></div>
            </div>
            <div className="flex my-1 space-x-2 items-center justify-center">

              <div className="w-20 h-20"><img alt="partners" src="https://ltfrb.gov.ph/wp-content/uploads/2017/09/Metro_Manila_Development_Authority_MMDA.png" /></div>
              <div className="w-20 h-20"><img alt="partners" src="https://ltfrb.gov.ph/wp-content/uploads/2017/09/Commission_on_Audit.png" /></div>
              <div className="w-20 h-20"><img alt="partners" src="https://ltfrb.gov.ph/wp-content/uploads/2017/09/Bureau_of_Internal_Revenue_BIR.png" /></div>
              <div className="w-20 h-20"><img alt="partners" src="https://ltfrb.gov.ph/wp-content/uploads/2017/09/Department_of_Trade_and_Industry_DTI.png" /></div>
              <div className="w-20 h-20"><img alt="partners" src="https://ltfrb.gov.ph/wp-content/uploads/2017/09/Department_of_Tourism_DOT.png" /></div>

            </div>
            <div className="flex my-1 space-x-2 items-center justify-center">

              <div className="w-20 h-20"><img alt="partners" src="https://ltfrb.gov.ph/wp-content/uploads/2017/09/SEC.png" /></div>
              <div className="w-20 h-20"><img alt="partners" src="https://ltfrb.gov.ph/wp-content/uploads/2017/09/office-of-the-ombudsman-logo.png" /></div>
              <div className="w-20 h-20"><img alt="partners" src="https://ltfrb.gov.ph/wp-content/uploads/2017/09/Bureau_of_Internal_Revenue_BIR.png" /></div>
              <div className="w-20 h-20"><img alt="partners" src="https://ltfrb.gov.ph/wp-content/uploads/2017/09/SEC.png" /></div>
              <div className="w-20 h-20"><img alt="partners" src="https://ltfrb.gov.ph/wp-content/uploads/2017/09/PHLPOST-Logo-200.png" /></div>

            </div>
          </Card.Body>
        </Card> */}
        {/* <Card>
          <Card.Header>
            <b className="title">Accredited Insurance</b>
          </Card.Header>
          <Card.Body>
            <div className="flex space-x-2 items-center justify-center">
              <div className="w-20 h-20"><img alt="Accredited Insurance" src="https://ltfrb.gov.ph/wp-content/uploads/2017/06/pami_400x400-1.jpg" /></div>
              <div className="w-20 h-20"><img alt="Accredited Insurance" src="https://ltfrb.gov.ph/wp-content/uploads/2017/10/SCCI.png" /></div>
            </div>
          </Card.Body>
        </Card> */}
      </div>
      <div className="right-pane">
        {routes.map(route => {
          return <RouteWithSubRoutes key={`dahboardRoute${get(route, 'path')}`} {...route}/>
        })}
      </div>
    </div>
  )
}

export default Dashboard